<template>
<div>
        <div v-if="page == 1">
              <el-row style="width: 98%; margin-top: 1%;">
              <el-col span="20">
                <el-input v-model="propertyDId" style="width: 50%;" placeholder="变更记录的ID"></el-input>
                <el-button type="primary" @click="selectPropertyId()">查看一个资产的变更记录</el-button>
                <el-button style="margin-left: 150px;" type="primary" @click="dialogFormVisible = true">资产变更申请</el-button>
                <el-dialog title="资产变更申请" :visible.sync="dialogFormVisible" width="25%">
                  <el-form>
                  <el-form-item label="需要变更资产的编号">
                    <el-input v-model="propertyId" style="width: 50%;" placeholder="资产的编号"></el-input>
                  </el-form-item>

                  <el-form-item label="变更后使用人的ID">
                    <el-input v-model="ownerId" style="width: 50%;" placeholder="使用人的ID"></el-input>
                  </el-form-item>

                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogFormVisible = false;add()">确 定</el-button>
                  </div>
                </el-dialog>

                <el-badge :value="200" :max="99" class="item">
                  <el-button  @click="ChangePage()">查看待审批的变更资产</el-button>
                </el-badge>

              </el-col>
              </el-row>






            <el-table
                :data="tableData"
                style="width: 100%;margin-top: 5%;">

                <el-table-column
                  prop="propertyRecordId"
                  label="变更编号"
                  width="180">
                </el-table-column>


                <el-table-column
                  prop="propertyName"
                  label="资产名称"
                  width="300">
                </el-table-column>


                <el-table-column
                  prop="afterUsername"
                  label="变更后使用人的名字"
                  width="250">
                </el-table-column>

                <el-table-column
                  prop="beforeUsername"
                  label="变更前使用人的名字"
                  width="250">
                </el-table-column>




                  <el-table-column
                    prop="recordState"
                    label="变更状态"
                    width="180">

                    <template slot-scope="scope">
                      <el-tag
                      :type = "scope.row.recordState == 1?'':(scope.row.recordState==2?'success':'danger')">
                        <div v-if="scope.row.recordState == 1">审核中</div>
                        <div v-if="scope.row.recordState == 2">变更已完成</div>
                      </el-tag>
                    </template>

                  </el-table-column>

                <el-table-column
                  label="创建时间"
                  width="180">
                  <template slot-scope="scope">{{ Date(createDate) | formateDate }}</template>
                </el-table-column>

              </el-table>
        </div>
         
        <div v-if="page!=2" style="margin-top: 2%;">
          <PropertyMyData></PropertyMyData>
        </div>


      <div v-if="page == 2">
        <PropertyMyChangeDeatil></PropertyMyChangeDeatil>
      </div>
      </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import PropertyMyChangeDeatil from "./Property_MyChangeDeatil.vue"
  import PropertyMyData from "./Property_MyData.vue"
  export default {
     name: 'Property_MyChange',
     components:{
       PropertyMyChangeDeatil,
       PropertyMyData
     },
     data () {
       return {
          dialogFormVisible:false,
          dialogChangeVisible:false,
           ownerId:'',
           propertyId:'',
           propertyId:'',
           recordId:'',
           page:1,
           tableRow:{
             afterUserId:'',
             afterUsername:'',
             beforeUserId:'',
             beforeUsername:'',
             createDate:'',
             propertyId:'',
             propertyName:'',
             propertyRecordId:'',
             recordState:'',
             unitId:'',
           },
              tableData: [{
                      afterUserId:'',
                      afterUsername:'',
                      beforeUserId:'',
                      beforeUsername:'',
                      createDate:'',
                      propertyId:'',
                      propertyName:'',
                      propertyRecordId:'',
                      recordState:'',
                      unitId:'',

                    }]

        };
     },
     mounted:function() {
	   // 表格里面的数据
       this.showData();

     },
     methods: {
	   // 点击按钮跳转页面，通过v-if来显示组件
	   //page=1的时候显示PropertyMyData
	   //page等于2的时候显示PropertyMyChangeDeatil页面
       ChangePage(){
         this.page = 2
       },


	  // 主要数据展示给tableData
      showData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 5,
       }
        this.axios({
            method: 'GET',
            url: '/public/getCheckRecord',

            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{

           this.tableData=resp.data.data;

          })
      },



	  //根据资产Id做筛选
      selectPropertyId(){
       var authorization = Cookies.get("Authorization");
         this.axios({
             method: 'GET',
             url: '/property/getCheckRecord',
             params:{
               propertyId:this.propertyDId,
             },
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.tableData=resp.data.data;
           })
       },


	 
      showReadData(){
        var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'POST',
            url: '/public/showWaitReadApply',
            header:{
              'Authorization':authorization,
              'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{

            this.tableData=resp.data.data;
           })
      },
	  //22行有使用申请人提交资产变更申请
      add(){
        var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'POST',
            url: '/public/applyChange',
            data: {
             propertyId:this.propertyId,
             ownerId:this.ownerId
            },  //这里json对象会转换成json格式字符串发送

            header:{
             // 'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          })

      },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_MyChange.vue